module.exports = __webpack_public_path__ + "static/media/Neosurf.15e10e49.svg";